import initialCameraProps from 'helpers/cameras/initialCameraProps'
import updateModel from 'reducers/updateModel'

export default model => updateModel(initialCameraProps(), { model, aov: model.aovs[0] || null })



// WEBPACK FOOTER //
// ./src/sagas/setupProjectsSaga/cameraWithModel.js